const errorFromValidate = (valid: boolean, message: string) => (valid ? undefined : message);

export default errorFromValidate;
